import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { empresa } from '../data/mock';

const Sobre = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-gradient-to-r from-purple-700 via-blue-700 to-cyan-600 text-white py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-4">Sobre a APA Informática</h1>
            <p className="text-xl opacity-90">
              Mais de 30 anos levando qualidade e confiança em serviços de informática para Belo Horizonte
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-slate-900 mb-6">Nossa História</h2>
              <div className="space-y-4 text-gray-700 text-lg">
                <p className="leading-relaxed">
                  A APA INFORMÁTICA é uma empresa especializada em assistência técnica, venda de notebooks e computadores em Belo Horizonte. 
                  Com mais de 30 anos de experiência, oferecemos soluções completas em informática com qualidade, confiança e preços justos.
                </p>
                <p className="leading-relaxed">
                  Localizada estrategicamente no bairro Ouro Preto, atendemos toda a região da Pampulha 
                  e adjacências com excelência e comprometimento.
                </p>
                <p className="leading-relaxed">
                  Contamos com uma estrutura completa para diagnóstico, reparo e venda de equipamentos, 
                  além de um estoque de peças originais e compatíveis das principais marcas do mercado.
                </p>
              </div>
            </div>

            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1721333089073-215a56fd710c?w=800&h=600&fit=crop"
                alt="Técnico trabalhando"
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-gradient-to-r from-purple-600 to-cyan-600 text-white p-6 rounded-xl shadow-lg">
                <p className="text-4xl font-bold">30+</p>
                <p className="text-lg">Anos de experiência</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-slate-900 text-center mb-12">
            Nossos Valores
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card className="text-center hover:shadow-xl transition-shadow">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl">✓</span>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Qualidade</h3>
                <p className="text-gray-600">
                  Utilizamos apenas peças de qualidade e seguimos os melhores padrões técnicos
                </p>
              </CardContent>
            </Card>

            <Card className="text-center hover:shadow-xl transition-shadow">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl">🤝</span>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Confiança</h3>
                <p className="text-gray-600">
                  Transparência em todos os orçamentos e serviços prestados
                </p>
              </CardContent>
            </Card>

            <Card className="text-center hover:shadow-xl transition-shadow">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl">🏆</span>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Experiência</h3>
                <p className="text-gray-600">
                  Mais de 30 anos de mercado com milhares de clientes satisfeitos
                </p>
              </CardContent>
            </Card>

            <Card className="text-center hover:shadow-xl transition-shadow">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl">🔧</span>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Profissionalismo</h3>
                <p className="text-gray-600">
                  Equipe técnica qualificada e atualizada com as novas tecnologias
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-r from-purple-700 via-blue-700 to-cyan-600 text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <p className="text-5xl font-bold mb-2">30+</p>
              <p className="text-xl opacity-90">Anos no mercado</p>
            </div>
            <div>
              <p className="text-5xl font-bold mb-2">5.0</p>
              <p className="text-xl opacity-90">Avaliação Google</p>
            </div>
            <div>
              <p className="text-5xl font-bold mb-2">1000+</p>
              <p className="text-xl opacity-90">Clientes atendidos</p>
            </div>
            <div>
              <p className="text-5xl font-bold mb-2">90</p>
              <p className="text-xl opacity-90">Dias de garantia</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-slate-900 text-center mb-6">
            Nossa Equipe
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
            Contamos com técnicos certificados e em constante atualização para oferecer 
            o melhor atendimento e soluções mais modernas do mercado.
          </p>

          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1768633647910-7e6fb53e5b0f?w=1200&h=600&fit=crop"
              alt="Equipe técnica"
              className="w-full h-96 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-purple-900/80 to-transparent flex items-end">
              <div className="p-8 text-white">
                <h3 className="text-3xl font-bold mb-2">Equipe Técnica Especializada</h3>
                <p className="text-lg opacity-90">
                  Profissionais certificados e comprometidos com a sua satisfação
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sobre;
